<template>
    <div>
        <!-- DIV CON LOS ELEMENTOS DE LA CABECERA -->
        <div class="row">
            <!-- Breadcrumb -->
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'integraciones' }">{{ $t("integraciones") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'businesscentral' }">{{ $t("businessCentral") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("formasDePago") }}</li>
                    </ol>
                </nav>
            </div>
        </div>

        <template v-if="mostrarEmpty">
            <div class="col-md-12 px-0">
                <div class="alert alert-success text-center">
                    <h3><i class="fas fa-check-circle"></i> {{ $t("noHayFormasDePagoPorConfigurar") }}</h3>
                    <p>{{ $t("formasDePagoConfiguradasCorrectamente") }}</p>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="container d-flex justify-content-center mt-4">
                <div class="d-flex justify-content-end" style="width: 80%;">
                    <button :disabled="!todasLasFormasDePagoSeleccionadas" @click="guardarFormasPagoFromBusinessCentral"
                        class="btn btn-success fixed-width-button finalizar-btn" role="button">
                        {{ $t("finalizar") }} <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-4">
                <div class="alert alert-info" style="width: 68%;" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <label class="labels" v-html="$t('formasDePagoBusinessCentralAlertInfo')"></label>
                </div>
            </div>

            <div class="container d-flex justify-content-center">
                <table class="product-table mt-3">
                    <thead>
                        <tr>
                            <th>{{ $t("codigo") }}</th>
                            <th>{{ $t("descripcion") }}</th>
                            <th>{{ $t("tipo") }}
                                <span style="color: red">*</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        <!-- <tr v-for="formaDePago in formasDePagoActualizar" :key="'actualizar-' + formaDePago.code">
                            <td>{{ formaDePago.code }}</td>
                            <td>{{ formaDePago.description }}</td>
                            <td>
                                <button
                                    :class="btn-warning"
                                    @click="">
                            <i
                              :class="'fa fa-sync-alt icon-check-table'"></i>
                             {{ $t("actualizar") }}
                          </button>
                            </td>
                        </tr> -->
                        <tr v-for="formaDePago in formasDePagoCrear" :key="'crear-' + formaDePago.code">
                            <td>{{ formaDePago.code }}</td>
                            <td>{{ formaDePago.description }}</td>
                            <td>
                                <el-select 
                                    v-model="formaDePago.tipoSeleccionado" 
                                    class="select-default w-100"
                                    :placeholder="$t('seleccioneUnTipo')"
                                    @change="actualizarTiposSeleccionados">
                                        
                                    <el-option 
                                        :label="$t('efectivo')" 
                                        value="E" 
                                        key="E"
                                        :disabled="!permitirEfectivo || 
                                            (tiposNoDisponibles.includes('E') && formaDePago.tipoSeleccionado !== 'E')">
                                    </el-option>
                                        
                                    <el-option 
                                        :label="$t('tarjeta')" 
                                        value="T" 
                                        key="T">
                                    </el-option>
                                            
                                    <el-option 
                                        :label="$t('cheque')" 
                                        value="C" 
                                        key="C">
                                    </el-option>
                                </el-select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Modal Bajas de Formas de Pago (Pendiente de adaptar del de Productos) -->
            <modal name="modal-downgrades" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
                <div>
                    <div class="modal-header wrapperTitle">
                        <h4 style="margin: 0px">{{ $t('productDowngrades') }}</h4>
                        <!-- <span class="close-btn" @click="closeDowngradesModal">&times;</span> -->
                    </div>

                    <!-- Body -->
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- Totales -->
                                <div class="form-group" v-if="downgradesPayMethods">
                                    <label>{{ $t("summary") }}</label>
                                    <p>
                                        <strong>{{ $t("totalDowngrades") }}:</strong> {{
                                            downgradesPayMethods.totalDowngrades }}<br>
                                        <strong>{{ $t("totalAffectedRecipes") }}:</strong> {{
                                            downgradesPayMethods.totalAffectedRecipes }}
                                    </p>
                                </div>
                            </div>

                            <!-- Lista de productos dados de baja -->
                            <div class="col-md-12"
                                v-if="downgradesPayMethods && downgradesPayMethods.downgrades && downgradesPayMethods.downgrades.length > 0">
                                <div class="form-group">
                                    <label>{{ $t("downgradedProducts") }}</label>
                                    <ul class="list-group">
                                        <li v-for="(product, index) in downgradesPayMethods.downgrades"
                                            :key="'DOWN-' + product.numierId" class="list-group-item">
                                            <strong>#{{ index + 1 }} {{ product.productName || $t("unknownProduct")
                                                }}</strong>
                                            <!-- <span class="text-muted"> (ID: {{ product.numierId }})</span> -->

                                            <!-- Recetas afectadas -->
                                            <div v-if="product.affectedRecipes && product.affectedRecipes.length > 0"
                                                class="mt-2">
                                                <label style="font-weight: bold;">{{ $t("affectedRecipes") }}:</label>
                                                <ul class="pl-3">
                                                    <li v-for="recipe in product.affectedRecipes"
                                                        :key="'REC-' + recipe.recipeId" class="flex items-center gap-2">
                                                        <i class="fa fa-cutlery"></i>
                                                        {{ recipe.name }}
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-else class="text-muted">
                                                {{ $t("noRecipesAffected") }}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button @click="closeDowngradesModal" class="btn btn-secondary">
                                <i class="fas fa-times"></i> {{ $t("cerrar") }}
                            </button>
                        </div>
                    </div>
                </div>
            </modal>

            <!-- Modal Actualizacion de Formas de Pago -->
            <modal name="modal-update-paymethods" :adaptive="true" :scrollable="true" height="auto" 
                :clickToClose="true">
                

                <div>
                    <!-- Header -->
                    <div class="modal-header wrapperTitle">
                        <h4 style="margin: 0px">{{ $t('updatedPaymentMethod') }}</h4>
                        <!-- <span class="close-btn" @click="closeDowngradesModal">&times;</span> -->
                    </div>

                    <!-- Body -->
                    <div class="modal-body">
                        <div class="row">
                            <!-- Lista de formas de pago actualizadas -->
                            <div class="col-md-12 ml-3">
                                <li v-for="paymentMethod in updatedPaymentMethods">

                                    <span v-html="$t('paymentMethodNameChanged', { oldName: paymentMethod.oldDescription, newName: paymentMethod.description })"></span>
                                </li>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button @click="hideModalUpdatePayMethods()" class="btn btn-secondary">
                                <i class="fas fa-times"></i> {{ $t("cerrar") }}
                            </button>
                        </div>
                    </div>


                </div>

            </modal>

        </template>

    </div>
</template>

<script>
import Swal from "sweetalert2";
import { Loading } from 'element-ui';
import { Select, Option } from "element-ui";
import { type } from "jquery";

export default {
    created() {
        this.listBusinesses = this.$route.params.listBusinesses;
        // console.log(" > listBusinesses recibido:", this.listBusinesses);

        // Si no existe listBusinesses, establecemos shouldRedirect en true y redirigimos
        if (!this.listBusinesses) {
            console.warn("listBusinesses no encontrado, redirigiendo a /integraciones...");
            this.shouldRedirect = true;  // Establecemos que se debe redirigir sin mostrar el modal
            //this.$router.replace("/integraciones");

            this.$router.push({ name: "integraciones", params: { redirected: true } });
        }

        this.getDatosFromPagoBusinessCentral(false);
        this.autoUpdatePaymentMethods(true);
        // this.bajaFormasPagoBusinessCentral();
        // .then(() => {
        //     this.getFormasDePagoPendientes(true);
        // });
    },

    data() {
        return {
            formasDePagoActualizar: [],
            formasDePagoCrear: [],
            formasDePagoBusinessCentral: [],
            formasDePagoPendientes: [],
            shouldRedirect: false,
            listBusinesses: [],
            permitirEfectivo: false,
            pendientesDarDeBaja: [],
            pendientesDarDeBajaNameList: [],
            mostrarEmpty: false,
            downgradesPayMethods: [],
            updatedPaymentMethods: [],
            updatedPaymentMethodsCount: 0,
        }
    },

    watch: {
        pendientesDarDeBajaNameList(newList) {
            if (newList && newList.length > 0) {
                this.mostrarModalBaja();
            }
        }
    },

    components: {
        'el-select': Select,
        'el-option': Option,
    },

    computed: {
        // Obtengo un array con los tipos de pago ya seleccionados
        tiposSeleccionados() {
            return this.formasDePagoCrear
                .filter(forma => forma.tipoSeleccionado)
                .map(forma => forma.tipoSeleccionado);
        },
        
        // Verifico si el efectivo ya ha sido seleccionado
        efectivoSeleccionado() {
            return this.tiposSeleccionados.includes('E');
        },

        // Verifico si todas las formas de pago tienen un tipo seleccionado
        todasLasFormasDePagoSeleccionadas() {
            return this.formasDePagoCrear.every(forma => forma.tipoSeleccionado);
        },
        
        // Obtengo los tipos de pago que ya están en uso y no deberían estar disponibles
        tiposNoDisponibles() {
            // Solo considero el efectivo como único, las demás pueden repetirse
            const efectivoSeleccionado = this.tiposSeleccionados.includes('E') ? ['E'] : [];
            
            // Uno con los tipos que ya existen en la base de datos
            const tiposEnUso = [...new Set([
                ...efectivoSeleccionado,
                ...(this.formasDePagoActualizar.map(forma => forma.tipo) || [])
            ])];
            
            return tiposEnUso;
        }
    },

    methods: {
        // Método para actualizar los tipos seleccionados cuando cambia un select
        actualizarTiposSeleccionados() {
            // Fuerzo la actualización de la interfaz
            this.$forceUpdate();
        },
        
        openDowngradesModal() {
            this.$modal.show("modal-downgrades");
        },

        closeDowngradesModal() {
            this.$modal.hide("modal-downgrades");
        },

        getDatosFromPagoBusinessCentral(mostrarLoading = true) {
            if (mostrarLoading) {
                this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
            }

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            return this.axios
                .get(this.$store.getters.apiUrl + "businesscentral/getFormasPagoFromBusinessCentral", config)
                .then((response) => {
                    if (response.data.response) {

                        //this.formasDePagoBusinessCentral = response.data.formasPago;
                        this.formasDePagoActualizar = response.data.toUpdate;
                        this.formasDePagoCrear = response.data.toCreate;
                        this.permitirEfectivo = response.data.permitirEfectivo;

                        if (this.formasDePagoActualizar.length === 0 && this.formasDePagoCrear.length === 0) {
                            this.mostrarEmpty = true;
                        }

                    }
                    if (mostrarLoading) {
                        this.loadingGeneral.close();
                    }



                })
                .catch((error) => {
                    console.error("Error al obtener formas de pago desde Business Central:", error);
                    if (mostrarLoading) {
                        this.loadingGeneral.close();
                    }
                });
        },

        autoUpdatePaymentMethods(mostrarLoading = true) {
            if (mostrarLoading) {
                this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
            }

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            const body = {};

            return this.axios
                .post(this.$store.getters.apiUrl + "businesscentral/updatePaymentMethodsBusinessCentral", body, config)
                .then((response) => {
                    if (response.data.response) {

                        //this.formasDePagoBusinessCentral = response.data.formasPago;
                        this.updatedPaymentMethods = response.data.updatedMethods;
                        this.updatedPaymentMethodsCount = response.data.updatedCount;

                    }
                    if (mostrarLoading) {
                        this.loadingGeneral.close();

                        if (this.updatedPaymentMethodsCount > 0) {
                            this.showModalUpdatePayMethods();
                        }
                    }



                })
                .catch((error) => {
                    console.error("Error al obtener formas de pago desde Business Central:", error);
                    if (mostrarLoading) {
                        this.loadingGeneral.close();
                    }
                });
        },

        // getFormasDePagoPendientes(mostrarLoading = true) {
        //     let config = {
        //         params: {
        //             jwt: this.$store.getters.jwt,
        //             formasPago: JSON.stringify(this.formasDePagoBusinessCentral),
        //             listBusinesses: JSON.stringify(this.listBusinesses),
        //         },
        //         headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
        //     };

        //     var params = {
        //         jwt: this.$store.getters.jwt,
        //     };

        //     this.axios
        //     .post(
        //         this.$store.getters.apiUrl + "formaspago/getFormasPagoPendientes",
        //         params,
        //         config
        //     )
        //     .then((response) => {
        //         console.log(" > RESPONSE DATA:", response.data.formasPagoPendientes);
        //         if (response.data.formasPagoPendientes) {
        //             this.formasDePagoPendientes = response.data.formasPagoPendientes;
        //             console.log(" > Formas de pago pendientes:", this.formasDePagoPendientes);
        //         }
        //     })
        //     .catch((error) => {
        //         console.error("Error al obtener formas de pago pendientes:", error);
        //     })
        //     .finally(() => {
        //         if (mostrarLoading) {
        //             this.loadingGeneral.close();
        //         }
        //     });
        // },

        guardarFormasPagoFromBusinessCentral() {

            const config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            var body = {
                listBusinesses: this.listBusinesses,
                formasPago: this.formasDePagoCrear,
            }

            this.axios
                .post(
                    this.$store.getters.apiUrl + "businesscentral/guardarFormasPagoFromBusinessCentral", body, config
                )
                .then(() => {
                    Swal.fire({
                        title: this.$t("formaPagoGuardada"),
                        text: this.$t("todasFormasPagoConfiguradas"),
                        type: "success",
                        confirmButtonText: this.$t("terminar"),
                        buttonsStyling: true,
                        confirmButtonClass: "btn btn-primary btn-fill swal2-cancel-btn",
                        confirmButtonColor: "#007bff",
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then(() => {
                        this.shouldRedirect = true;
                        this.$router.push({ name: "businesscentral", params: { redirected: false } });
                    });
                })
                .catch((error) => {
                    console.error("Error al guardar formas de pago:", error);
                });
        },

        beforeRouteLeave(to, from, next) {
            // console.log(" > Intentando salir de:", from.fullPath);
            // console.log(" > Intentando ir a:", to.fullPath);

            if (!this.shouldRedirect) {

                Swal.fire({
                    title: this.$t("swalSalirFromProductosBusinessCentralTitle"),
                    text: this.$t("swalSalirFromProductosBusinessCentralText"),
                    type: "info",
                    showCancelButton: true,
                    cancelButtonClass: "btn btn-secondary btn-fill",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    confirmButtonColor: "#d33",
                    confirmButtonText: this.$t("swalSalirFromProductosBusinessCentralButtonConfirm"),
                    cancelButtonText: this.$t("cancelar"),
                    buttonsStyling: true,
                    focusCancel: true,
                }).then((result) => {
                    if (result.value) {
                        // console.log(" > Confirmado. Navegando a:", to.fullPath);
                        next();

                    } else {
                        // console.log(" > Cancelada la navegación.");
                        next(false);
                    }
                });
            } else {
                next();
            }
        },

        // Elimino esto que no tiene sentido
        // mostrarModalBaja() {
        //     if (!this.pendientesDarDeBajaNameList.length === 0) return;

        //     const listadoHTML = this.pendientesDarDeBajaNameList
        //         .map(nombre => `<li>${nombre}</li>`)
        //         .join("");

        //     Swal.fire({
        //         title: this.$t('atencion'),
        //         html: `
        //             <div style="text-align:left">
        //             ${this.$t('formasPagoDarDeBajaMensaje')}:
        //             <br/><br/><ul>${listadoHTML}</ul>
        //             ${this.$t('pulsaDarDeBaja')}
        //             </div>
        //         `,
        //         icon: "warning",
        //         confirmButtonText: this.$t('darDeBaja'),
        //         buttonsStyling: true,
        //         confirmButtonClass: "btn btn-primary btn-fill swal2-cancel-btn",
        //         confirmButtonColor: "#007bff",
        //         allowOutsideClick: false,
        //         allowEscapeKey: false
        //     }).then(result => {
        //         if (result.value) {
        //             this.bajaFormasPagoBusinessCentral();
        //         }
        //     });
        // },

        bajaFormasPagoBusinessCentral() {
            const config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: {
                    Authorization: "Bearer " + this.$store.getters.jwt
                }
            };

            this.loadingGeneral = Loading.service({ text: this.$t('dandoDeBajaFormasPago') });

            this.axios
                .post(this.$store.getters.apiUrl + "formaspago/bajaFormasPagoFromBusinessCentral", {}, config)
                .then(response => {
                    this.loadingGeneral.close();
                    if (response.data.response) {
                        this.$notify({
                            type: "success",
                            message: this.$t('formasPagoDadasDeBaja')
                        });

                        // Puedes recargar la lista actualizada si quieres
                        this.getDatosFromPagoBusinessCentral(false);

                    } else {
                        this.$notify({
                            type: "danger",
                            message: response.data.message || this.$t('errorDarDeBajaFormasPago')
                        });
                    }
                })
                .catch(error => {
                    this.loadingGeneral.close();
                    // console.error(" > Error en bajaFormasPagoBusinessCentral:", error);
                    this.$notify({
                        type: "danger",
                        message: this.$t('errorServidorDarDeBaja')
                    });
                });
        },

        showModalUpdatePayMethods() {
            this.$modal.show("modal-update-paymethods");
        },

        hideModalUpdatePayMethods() {
            this.$modal.hide("modal-update-paymethods");

            if (this.formasDePagoCrear.length === 0) {
                this.shouldRedirect = true;
                this.$router.push({ name: "businesscentral", params: { redirected: false } });
            }
        },
    },

}
</script>

<style scoped>
.table-container {
    margin-left: 15%;
    margin-right: 15%;
    width: 80%;
    overflow-x: auto;
}

.product-table {
    width: 80%;
    table-layout: fixed;
    border-collapse: collapse;
    background-color: #f7f7f8;
}

.product-table th,
.product-table td {
    padding: 10px;
    padding-top: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    border-top: 1px solid #ccc;
    text-align: left;
    font-size: 15px;
}

/* Quitar el borde superior de la primera fila y el borde inferior de la última fila */
.product-table tr:first-child th {
    border-top: none;
}

.product-table tr:last-child td {
    border-bottom: none;
}

.product-table th {
    padding-bottom: 10px;
    background-color: #f7f7f8;
}

.select-btn {
    width: 120px;
    font-size: 15px;
    padding: 5px 10px;
    text-align: center;
}

.alert-container-wide {
    margin-left: 35px;
}

.alert-info {
    font-size: 20px;
    color: #0c5460 !important;
    background-color: #ffffff !important;
    border-color: #0c5460 !important;
    position: relative;
    padding-left: 45px;
    padding-right: 10px;
    padding-bottom: 2px !important;
    margin-top: 2px;
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.55rem;
    box-sizing: border-box;
}

.fa-info-circle {
    position: absolute;
    left: 20px;
    top: 14px;
    right: 10px;
    bottom: 15px;
    font-size: 15px;
    color: #0c5460;
}

.labels {
    font-size: 15px;
}

.finalizar-btn:disabled {
    background-color: #cccccc !important;
    color: #888888 !important;
    border-color: #cccccc !important;
    cursor: not-allowed !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/BusinessCentral/FormasDePago/FormasDePagoBusinessCentral.vue